import React, { useRef, useEffect, useState } from "react";
import lottie, { AnimationItem } from "lottie-web";
import envelope from "./envelop.json";
import * as S from "./styles";

interface Props {
  visible: boolean;
  onClose: () => void;
}

const EnvelopeAnimation: React.FC<Props> = ({ visible, onClose }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const confettiRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(visible);
  const [envelopeOpened, setEnvelopeOpened] = useState(false);

  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  useEffect(() => {
    let envelopeAnimation: AnimationItem | null = null;
    let confettiAnimation: AnimationItem | null = null;

    if (isVisible && containerRef.current) {
      // Animação principal do envelope (uma vez só)
      envelopeAnimation = lottie.loadAnimation({
        container: containerRef.current,
        renderer: "svg",
        loop: false,
        autoplay: true,
        animationData: envelope,
      });

      // Quando a animação terminar, manter o último frame
      envelopeAnimation.addEventListener("complete", () => {
        // Garante que a animação pare no último frame (carta aberta)
        envelopeAnimation?.goToAndStop(envelopeAnimation.totalFrames - 1, true);
        setEnvelopeOpened(true);

        // Agora vamos iniciar a animação de confetes em loop
        setTimeout(() => {
          if (confettiRef.current) {
            // Limpe qualquer conteúdo prévio
            confettiRef.current.innerHTML = "";

            // Crie uma nova animação apenas para os confetes
            confettiAnimation = lottie.loadAnimation({
              container: confettiRef.current,
              renderer: "svg",
              loop: true,
              autoplay: true,
              animationData: envelope,
              // Ajuste esses valores para mostrar apenas a parte dos confetes
              // Tente diferentes valores para encontrar apenas os confetes
              initialSegment: [58, 120],
            });

            // Forçar a animação de confetes a começar do início
            confettiAnimation.goToAndPlay(58, true);
          }
        }, 500); // Pequeno atraso para garantir que o envelope tenha congelado
      });
    }

    return () => {
      if (envelopeAnimation) {
        envelopeAnimation.removeEventListener("complete");
        envelopeAnimation.destroy();
      }
      if (confettiAnimation) {
        confettiAnimation.destroy();
      }
    };
  }, [isVisible]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <S.EnvelopeWrapper>
      <S.CloseButton onClick={handleClose}>x</S.CloseButton>
      <S.EnvelopeContainer ref={containerRef} />
      <S.ConfettiContainer ref={confettiRef} />
    </S.EnvelopeWrapper>
  );
};

export default EnvelopeAnimation;
